import { render, staticRenderFns } from "./VerifyLibrarySign.vue?vue&type=template&id=a270e4d6&scoped=true&"
import script from "./VerifyLibrarySign.vue?vue&type=script&lang=js&"
export * from "./VerifyLibrarySign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a270e4d6",
  null
  
)

export default component.exports